import { createGlobalStyle } from 'styled-components';

import ProximaNovaRegularWoff2 from './ProximaNova/ProximaNova-Regular.woff2';
import ProximaNovaRegularWoff from './ProximaNova/ProximaNova-Regular.woff';

import ProximaNovaSemiBoldWoff2 from './ProximaNova/ProximaNova-Semibold.woff2';
import ProximaNovaSemiBoldWoff from './ProximaNova/ProximaNova-Semibold.woff';

import ProximaNovaBoldWoff2 from './ProximaNova/ProximaNova-Bold.woff2';
import ProximaNovaBoldWoff from './ProximaNova/ProximaNova-Bold.woff';

export default createGlobalStyle`
    @font-face {
        font-family: "ProximaNova";
        src: url(${ProximaNovaRegularWoff2}) format("woff2"),
            url(${ProximaNovaRegularWoff}) format("woff");
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
    }

    @font-face {
        font-family: "ProximaNova";
        src: url(${ProximaNovaSemiBoldWoff2}) format("woff2"),
            url(${ProximaNovaSemiBoldWoff}) format("woff");
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
    }
    
    @font-face {
      font-family: "ProximaNova";
      src: url(${ProximaNovaBoldWoff2}) format("woff2"),
      url(${ProximaNovaBoldWoff}) format("woff");
      font-weight: 700;
      font-style: normal;
      font-stretch: normal;
    }
    
    h1,h2,h3,h4,h5 {
        font-family: "ProximaNova", Arial, sans-serif;
        font-weight: 600;
    }

    html body {
        font-family: "ProximaNova", Arial, sans-serif;
        p, span {
            font-family: "ProximaNova", Arial, sans-serif;
        }
    }


    strong, b {
        font-weight: 600;
    }

    h1 strong, h1 b,
    h2 strong, h2 b,
    h3 strong, h3 b,
    h4 strong, h4 b,
    h5 strong, h5 b {
        font-weight: 700;
    }
`;
